import { render, staticRenderFns } from "./CategoryTypePage.vue?vue&type=template&id=8c80ab86&scoped=true&"
import script from "./CategoryTypePage.vue?vue&type=script&lang=js&"
export * from "./CategoryTypePage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTypePage.vue?vue&type=style&index=0&id=8c80ab86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c80ab86",
  null
  
)

export default component.exports